import React from 'react';
import './RowsPerPagePicker.css';
import { AppEnum, BATCH_CAPACITY_OPTIONS, BatchCapacity, FaListUl, ReactSelectField, useDataTableContext } from '@/Shared';

/**
 * Author: Samano CASTRE
 * Date: 2025-06-29
 * 
 * Description:
 * RowsPerPagePicker is a dropdown component that allows the user to select
 * how many rows should be displayed per page in a data table.
 * It takes a default value and emits changes via the `onRowPick` callback.
 */
function RowsPerPagePicker<VM extends Record<string, any>>() {

	const { batchCapacity, processedDataCount, updateBatchCapacity } = useDataTableContext<VM>();
	const options = BATCH_CAPACITY_OPTIONS.map(
		opt => { 
			return { 
				key: String(opt), 
				value: String(opt), 
				label: String(opt) 
			} 
		}) as AppEnum[];


	return (
		<div className='RowsPerPagePicker' id="RowsPerPagePicker">
			<ReactSelectField
				required
				label="Tranche de données"
				icon={<FaListUl />}
				name="batchCapacity"
				options={options}
				field={{
					name: "batchCapacity",
					value:batchCapacity
				}}
				form={{
					setFieldValue: (name: string, value: BatchCapacity) => {
						return updateBatchCapacity(value);
					}
				}}
				scrollParent={document.querySelector('#RowsPerPagePicker') as HTMLDivElement}
			/>
			<div className='DataTable__result-count'>Résultats : {processedDataCount}</div>
		</div>
	);
}

export default RowsPerPagePicker;